<app-modal class="add-edit-event-modal">
  <h1 class="h2" *ngIf="!showMultiple">Create Event</h1>
  <div class="mt-0150 mb-0025">

    <ng-container *ngIf="!showMultiple">
      <app-event-form #eventFormRef
                      class="d-block"
                      [calendarEvent]="calendarEvent"
                      (startDateChanged)="startDateChanged($event)"
                      (calendarEventUpdated)="calendarEventUpdated($event)"></app-event-form>

      <h5 class="caps caps--light mt-0075 mb-0050 txt-12">Tasks</h5>
      <div [formGroup]="taskForm" class="mb-0100">
        <div>
          <mat-slide-toggle formControlName="Confirm">{{ getCreateTaskLabel('Confirm') }}</mat-slide-toggle>
        </div>
        <div>
          <mat-slide-toggle formControlName="DoubleConfirm">{{ getCreateTaskLabel('DoubleConfirm') }}</mat-slide-toggle>
        </div>
        <div>
          <mat-slide-toggle formControlName="LogAttendance">{{ getCreateTaskLabel('LogAttendance') }}</mat-slide-toggle>
        </div>
      </div>

      <app-error-notification [errors]="errorMessages"></app-error-notification>

    </ng-container>

    <ng-container *ngIf="!showMultiple">
      <app-an-event-sync-options #eventSyncComponent></app-an-event-sync-options>
    </ng-container>

    <app-multiple-events-component (onEventCreated)="eventsCreated($event)"
                                   (onBack)="showMultiple = false"
                                   *ngIf="showMultiple"
                                   [originalEvent]="calendarEvent"></app-multiple-events-component>

    <div class="row dual-btn-row with-gap mt-0150 flexJustify--end"
         *ngIf="!showMultiple">
      <button type="button"
              class="btn btn--white"
              (click)="createMultipleEventsClicked()"
              [disabled]="isSubmitting || enableEventSync">
        Create multiple events
      </button>
      <button type="button"
              class="btn mt-0"
              (click)="createEventClicked()"
              [disabled]="isSubmitting">
        Create event
      </button>
    </div>

  </div>
</app-modal>
